import { styled } from '../jss-style';
import tooltipStyle from './tooltip';

const useTooltipStyle = styled(tooltipStyle, 'tooltip');
export { tooltipStyle, useTooltipStyle };
export default useTooltipStyle;
